import { BASE_URL } from "../constants/url";
import i18next from "../i18n";

export const redirectToLogin = () => {
  const currentLocale = i18next.language === "en" ? "" : `/${i18next.language}`;
  window.location.href = `${BASE_URL}${currentLocale}/for-organizers/login`;
};
